import React from 'react';
import style from './style.scss';

export default function SkeletonCard() {
  return (
    <div>
      <div className={style.card} />
      <div
        className={style.section}
        style={{
          width: '100%',
          marginTop: '.2rem',
        }}
      />
      <div
        className={style.section}
        style={{
          width: '2.28rem',
          marginTop: '4px',
        }}
      />
      <div className={style.info}>
        <div className={style.square} />
        <div
          className={style.section}
          style={{
            width: '1.14rem',
          }}
        />
      </div>
    </div>
  );
}
